var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.000000 99.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,99.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304 871 c-44 -27 -70 -96 -55 -144 37 -111 186 -125 235 -22 21 44 20 83 -4 122 -37 61 -116 81 -176 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 593 c-65 -32 -71 -54 -71 -275 l0 -198 220 0 220 0 0 204 c0 193 -1 205 -22 231 -34 44 -75 55 -200 55 -85 0 -121 -5 -147 -17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.3759f37848da04dbbdce1a7ca4811e27.svg";
export { ForwardRef as ReactComponent };